const BlueImage = ({ style, alt, ...props }) => <img alt={alt} style={{ filter: "sepia(100%) saturate(600%) hue-rotate(190deg) brightness(100%) contrast(100%)", ...style }} {...props} />;

export default BlueImage;
